import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { RoomStatusEnum } from '@zaoblako/shared/modules/catalog/enums/room-status.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string represenations of {@link RoomStatusEnum} enumeration values */
export const RoomStatusEnumI18n: EnumI18nInterface<RoomStatusEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [RoomStatusEnum.RENTED]: 'Сдано',
    [RoomStatusEnum.FREE]: 'Свободно',
    [RoomStatusEnum.RESERVE]: 'Резерв',
    [RoomStatusEnum.ON_REPAIR]: 'На ремонте',
  },
  [I18nLocalesEnum.EN_US]: {
    [RoomStatusEnum.RENTED]: 'Rented',
    [RoomStatusEnum.FREE]: 'Free',
    [RoomStatusEnum.RESERVE]: 'Reserve',
    [RoomStatusEnum.ON_REPAIR]: 'On repair',
  },
};
